
const Settings = () => {
  return (
    <div>
      
    </div>
  )
}

export default Settings
